import type {
  BlockTooltipAddOn,
  TooltipPlacementPosition,
} from '@unifyapps/defs/blocks/common/tooltipTypes';

// icon buttons saved before the tooltip add-on arch persist as { content, tooltipPlacement }.
// the add-on arch expects { type, placementBehavior, placementPosition }, so map the old
// shape to the new one at read time — this keeps existing buttons working without a data migration.
type LegacyIconButtonTooltip = {
  tooltipPlacement?: TooltipPlacementPosition;
};

export function normalizeIconButtonTooltip(
  tooltip: (BlockTooltipAddOn & LegacyIconButtonTooltip) | undefined,
): BlockTooltipAddOn | undefined {
  if (!tooltip) {
    return undefined;
  }

  const { tooltipPlacement, ...rest } = tooltip;
  const type = rest.type ?? 'text';

  // old data carries a placement but none of the new placement fields — treat it as a manual placement
  if (tooltipPlacement && !rest.placementBehavior && !rest.placementPosition) {
    return {
      ...rest,
      type,
      placementBehavior: 'manual',
      placementPosition: tooltipPlacement,
    };
  }

  return { ...rest, type };
}
